import type { TabKey } from "./types";

interface Counts {
  all: number;
  permanent: number;
  temporary: number;
  sandbox: number;
}

interface Props {
  active: TabKey;
  counts: Counts;
  onChange: (tab: TabKey) => void;
}

const TABS: { key: TabKey; label: string }[] = [
  { key: "all",       label: "全部" },
  { key: "permanent", label: "永久" },
  { key: "temporary", label: "临时" },
  { key: "sandbox",   label: "沙盒" },
];

export default function AdAccountTabs({ active, counts, onChange }: Props) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {TABS.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={
              "flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition " +
              (isActive
                ? "bg-foreground text-background"
                : "bg-background border border-border text-foreground hover:bg-muted")
            }
          >
            <span>{t.label}</span>
            <span className={
              "rounded px-1.5 py-0.5 text-xs " +
              (isActive ? "bg-background/20 text-background" : "bg-muted text-muted-foreground")
            }>
              {counts[t.key]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
